import styled from 'styled-components';

export const ContractSearchStyled = styled.div`
  display: flex;
  flex: 1 0;
  justify-content: flex-end;
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .search-type {
    width: 10rem;
  }
  .search-value {
    width: 30rem;
  }
`;
